<template>
  <div class="customer" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.customer.id">
            {{ util.language('新增', 'New ') }}
          </template>
          <template v-else>
            {{ util.language('编辑', 'Edit ') }}
          </template>
          {{ util.language('客户', 'Customer') }}
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">{{ util.language('返回', 'Back') }}</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">{{ util.language('保存', 'Save') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="ID" v-if="data.customer.id">
        <el-input v-model="data.customer.id" disabled />
      </el-form-item>
      <el-form-item :label="util.language('状态', 'State')">
        <el-select clearable v-model="data.customer.enable" style="width: 100%;">
          <el-option :key="true" :label="util.language('启用', 'Enable')" :value="true" />
          <el-option :key="false" :label="util.language('停用', 'Disable')" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item :label="util.language('编码', 'Code')">
        <el-input v-model="data.customer.code" disabled />
      </el-form-item>
      <el-form-item label=" ">
        <el-collapse v-model="show.usingGoogleMap" style="width: 100%;" name="googleMap">
          <el-collapse-item :title="util.language('使用Google地图选择地点信息', 'Use Google Map to select location information')">
            <div>
              <el-input v-model="data.mapKeyWord" :placeholder="util.language('输入地址关键字搜索', 'Enter address keyword to search')" style="width:calc(100% - 100px);" />
              <el-button @click="searchPlace" type="primary" style="margin-left: 20px; width: 80px;">{{ util.language('搜索', 'Search') }}</el-button>
              <el-table :data="show.placeList" style="width: 100%;" max-height='130px' :show-header="false" size="small">
                <el-table-column prop="name" width="300" show-overflow-tooltip />
                <el-table-column prop="formattedAddress" show-overflow-tooltip />
                <el-table-column width="80" aline="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-link @click="clickPlace(scope.row)" type="primary" size="small">{{ util.language('选择', 'Select') }}</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div id="map" style="width: 100%;height: 300px;margin-top: 2px;"></div>
            <div style="margin-top: 20px;" v-if="show.placeInfo">
              <el-text style="margin-right: 20px;">{{ util.language('名称：', 'Name: ') }}</el-text>
              <el-text>{{ show.placeInfo.name }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('地址：', 'Address: ') }}</el-text>
              <el-text>{{ show.placeInfo.formattedAddress }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('坐标：', 'Coordinates: ') }}</el-text>
              <el-text>{{ show.placeInfo.lat }}, {{ show.placeInfo.lng }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('电话：', 'Phone: ') }}</el-text>
              <el-text>{{ show.placeInfo.phone }}</el-text>
              <br />
              <el-text style="margin-right: 20px;">{{ util.language('营业时间：', 'Opening Hours: ') }}</el-text>
              <el-text>{{ show.placeInfo.openingHours }}</el-text>
              <br />
              <el-button type="primary" size="small" @click="confirmPlace">{{ util.language('确认，并快速填写', 'Confirm and fill in quickly') }}</el-button>
              <el-button size="small" @click="show.usingGoogleMap = []">{{ util.language('关起', 'Close') }}</el-button>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-form-item>
      <el-form-item :label="util.language('名称', 'Name')">
        <el-input v-model="data.customer.name" />
      </el-form-item>
      <el-form-item :label="util.language('联系电话', 'Phone')">
        <el-input v-model="data.customer.phone" />
      </el-form-item>
      <el-form-item :label="util.language('Google地点ID', 'Google Place ID')">
        <el-tooltip :content="util.language('请在地图中搜索并选择点位，不可直接编辑', 'Please search and select the point in the map, do not edit directly')" placement="top">
          <el-input v-model="data.customer.googlePlaceId" style="width: 40%;" disabled />
        </el-tooltip>
        <el-input v-model="data.customer.lat" style="width: 25%;margin-left: 5%;" disabled />
        <el-input v-model="data.customer.lng" style="width: 25%;margin-left: 5%;" disabled />
      </el-form-item>
      <el-form-item :label="util.language('营业时间', 'Opening Hours')">
        <template v-if="data.customer && data.customer.openingHours">
          <div style="width: 100%;" v-for="openingHoursItem, index in data.customer.openingHours.split(',')" :key="index">
            <el-text>{{ openingHoursItem }}</el-text>
          </div>
        </template>
      </el-form-item>
      <el-form-item :label="util.language('详细地址', 'Address')">
        <el-input v-model="data.customer.addressDetail" />
      </el-form-item>
      <el-form-item :label="util.language('客户备注', 'Customer Note')">
        <el-input v-model="data.customer.customerNote" disabled />
      </el-form-item>
      <el-form-item :label="util.language('内部备注', 'Insider Note')">
        <el-input type="textarea" :rows="3" v-model="data.customer.insiderNote" />
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import { Loader } from '@googlemaps/js-api-loader'

const shopId = cache.getString(cache.keys.shopId) * 1
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}
const router = useRouter()
const loading = reactive({
  save: false,
})
const show = reactive({
  usingGoogleMap: [],
  placeList: [], // 地点搜索结果
  placeInfo: null, // 地点信息
})
const pageParam = cache.getObject(cache.keys.pageParam + "customer")
const data = reactive({
  customer: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {},
  mapKeyWord: '', // 谷歌地图搜索关键词
})

const mapLoader = new Loader({
  apiKey: 'AIzaSyBi5KgsssFebf3i05F_llpS8poRAnHXXpU',
  libraries: ['places'],
});

/** 搜索地址 */
const searchPlace = () => {
  const params = {
    keyWord: data.mapKeyWord
  }
  api.get('/backend/map/byKeyword', { params }).then(res => {
    if (res.list.length === 0) {
      ElMessage.warning(util.language('没查询到位置', 'No location found'))
    }
    show.placeList = res.list
  })
}

/** 选中一个地址 */
const clickPlace = (place) => {
  data.map.setCenter({ lat: place.lat, lng: place.lng })
  data.map.setZoom(18)
  if (!place.phone) {
    api.get('/backend/map/byId', { params: { placeId: place.placeId } }).then(res => {
      place.openingHours = res.openingHours
      place.phone = res.phone
      show.placeInfo = place
    })
  } else {
    show.placeInfo = place
  }
}

/** 确认选择的地址 */
const confirmPlace = () => {
  data.customer.name = show.placeInfo.name
  data.customer.phone = show.placeInfo.phone
  data.customer.addressDetail = show.placeInfo.formattedAddress
  data.customer.googlePlaceId = show.placeInfo.placeId
  data.customer.lat = show.placeInfo.lat
  data.customer.lng = show.placeInfo.lng
  data.customer.openingHours = show.placeInfo.openingHours
}

const save = () => {
  loading.save = true
  if (!data.customer.id) {
    api.post('/backend/customer/addCustomer', {
      code: data.customer.code,
      name: data.customer.name,
      phone: data.customer.phone,
      googlePlaceId: data.customer.googlePlaceId || '',
      lat: data.customer.lat,
      lng: data.customer.lng,
      openingHours: data.customer.openingHours || '',
      addressDetail: data.customer.addressDetail,
      enable: data.customer.enable,
      customerNote: '',
      insiderNote: data.customer.insiderNote || '',
      shopId: shopId,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'Success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    api.post('/backend/customer/setCustomer', {
      id: data.customer.id,
      name: data.customer.name,
      phone: data.customer.phone,
      googlePlaceId: data.customer.googlePlaceId || '',
      lat: data.customer.lat,
      lng: data.customer.lng,
      openingHours: data.customer.openingHours || '',
      addressDetail: data.customer.addressDetail,
      enable: data.customer.enable,
      insiderNote: data.customer.insiderNote || '',
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'Success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}

onMounted(() => {
  mapLoader.importLibrary('maps').then(mapsLoader => {
    // 初始化MAP
    data.map = new mapsLoader.Map(document.getElementById('map'), {
      center: { lat: 43.70, lng: -79.4 },
      zoom: 11,
      mapId: 'b0129775b4e1462ad56c1bf4',
      mapTypeControl: false, // 禁用地图模式切换按钮
    })
  })
})
</script>

<style lang="less">
.customer {
  margin: auto;
  max-width: 900px;
}
</style>